export enum OtpCode {
  failed = 'otp_failed',
  missing = 'otp_missing',
}
